<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style lang="less">
  html, body, #app {
    width: 100%;
    height: 100%;
  }
  .el-tab-pane, .el-table tr {
    background-color: @boxBgColor;
  }
  .el-scrollbar{
	  overflow-x: hidden !important;
  }
  .el-scrollbar__wrap{
  	  overflow-x: hidden !important;
	  margin-bottom: 0 !important;
  }
  // ::-webkit-scrollbar {
	 //  display: none;
  // }
</style>



// WEBPACK FOOTER //
// src/App.vue